import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalytic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Analytics" }), /* @__PURE__ */ _jsx("path", {
		d: "M9.66671 1.89258V5.3347C9.66671 5.80141 9.66671 6.03476 9.75754 6.21302C9.83743 6.36982 9.96491 6.49731 10.1217 6.5772C10.3 6.66803 10.5333 6.66803 11 6.66803H14.4422M4.66671 12.5013V15.0013M11.3334 10.8346V15.0013M8.00004 8.7513V15.0013M14.6667 8.32482V14.3346C14.6667 15.7348 14.6667 16.4348 14.3942 16.9696C14.1545 17.44 13.7721 17.8225 13.3017 18.0622C12.7669 18.3346 12.0668 18.3346 10.6667 18.3346H5.33337C3.93324 18.3346 3.23318 18.3346 2.6984 18.0622C2.22799 17.8225 1.84554 17.44 1.60586 16.9696C1.33337 16.4348 1.33337 15.7348 1.33337 14.3346V5.66797C1.33337 4.26784 1.33337 3.56777 1.60586 3.03299C1.84554 2.56259 2.22799 2.18014 2.6984 1.94045C3.23318 1.66797 3.93324 1.66797 5.33337 1.66797H8.00985C8.62133 1.66797 8.92707 1.66797 9.21479 1.73704C9.46988 1.79829 9.71374 1.8993 9.93742 2.03637C10.1897 2.19097 10.4059 2.40716 10.8383 2.83954L13.4951 5.4964C13.9275 5.92878 14.1437 6.14497 14.2983 6.39726C14.4354 6.62094 14.5364 6.8648 14.5976 7.11989C14.6667 7.40761 14.6667 7.71335 14.6667 8.32482Z",
		stroke: "#B93815",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgAnalytic;
